import React, { useState, forwardRef, Component, useEffect } from 'react';
import {useDispatch} from 'react-redux';
import {denormCompanyUpdate} from "./entityVerificationsSlice";
import _ from 'lodash';
import {DropdownOptions} from "./enums/DropdownOptions";

export const ContactEditor = forwardRef((props, ref) => {

    const gridApi = props.api;
    const uiAttributeName = props.colDef.headerName;
    const attributeType = props.attributeType;
    const attributeDenormPrefix = props.attributeDenormPrefix;
    const entityIdColumn = props.entityIdColumn;

    const verifiedByOptions = props.verifiedByOptions ? props.verifiedByOptions : 'default_verified_by';
    const invalidatedReasonOptions = props.invalidatedReasonOptions ? props.invalidatedReasonOptions : 'default_invalidated_reasons'


    const [rowData, setRowData] = useState( props.data);
    const [rowIndex, setRowIndex] = useState(props.rowIndex);
    const [submitEnabled, setSubmitEnabled] = useState(false);

    const [attributeColumn, setAttributeColumn] = useState( props.column.colId);
    const [attributeValue, setAttributeValue] = useState(rowData[attributeDenormPrefix]);
    const [attributeId, setAttributeId] = useState(rowData[attributeDenormPrefix+'Id']);
    const [honorific, setHonorific] = useState(props.data[attributeDenormPrefix+'Honorific']);
    const [givenName, setGivenName] = useState(props.data[attributeDenormPrefix+'GivenName']);
    const [middleName, setMiddleName] = useState(props.data[attributeDenormPrefix+'MiddleName']);
    const [surname, setSurname] = useState(props.data[attributeDenormPrefix+'Surname']);
    const [maturitySuffix, setMaturitySuffix] = useState(props.data[attributeDenormPrefix+'MaturitySuffix']);
    const [professionalSuffix, setProfessionalSuffix] = useState(props.data[attributeDenormPrefix+'ProfessionalSuffix']);

    const [verifiedBy, setVerifiedBy] = useState(setVerifiedByBeginState(rowData[attributeDenormPrefix+'VerifiedBy']));
    const [invalidatedReason, setInvalidatedReason] = useState(setInvalidatedReasonBeginState(rowData[attributeDenormPrefix+'InvalidatedReason']));
    const dispatch = useDispatch();

    // Set global flag when editor opens
    useEffect(() => {
        window.isCellEditorOpen = true;
        console.log('ContactEditor opened - setting global flag');
        
        // Cleanup when editor closes
        return () => {
            window.isCellEditorOpen = false;
            console.log('ContactEditor closed - clearing global flag');
        };
    }, []);

    function setVerifiedByBeginState(beginValue){

        //alert(`verified begin value = ${beginValue}`);
        const validVerifieds = DropdownOptions[verifiedByOptions].map((option)=>option.value);

        if(beginValue === null){
            return '---';
        }
        else if(validVerifieds.includes(beginValue)){
            return beginValue;
        }
        else{
            return '[Entity Verification] - Other';
        }
    }

    function setInvalidatedReasonBeginState(beginValue){

        const validReasons =  DropdownOptions[invalidatedReasonOptions].map((option)=>option.value);

        if(beginValue === null){
            return '---';
        }
        else if(validReasons.includes(beginValue)){
            return beginValue;
        }
        else{
            return '[Entity Verification] - Other';
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault(); //prevent refresh on submit
        try {
            dispatch(denormCompanyUpdate({
                entityVerificationId: rowData["id"],
                companyId: rowData["companyId"],
                entityId: rowData[entityIdColumn],
                attributeType: attributeType,
                attributeDenormPrefix: attributeDenormPrefix,

                attributeId: rowData[attributeDenormPrefix+'Id'],
                columns: {  honorific: honorific,
                            givenName: givenName,
                            middleName: middleName,
                            surname: surname,
                            maturitySuffix: maturitySuffix,
                            professionalSuffix: professionalSuffix,
                            verifiedBy: verifiedBy === '---' ? null : verifiedBy,
                            invalidatedReason: invalidatedReason === '---' ? null: invalidatedReason},
                rowIndex: rowIndex
            }));

            // Close the modal after submitting
            gridApi.stopEditing();
            // if (url) url.current.focus();
        }
        catch (err){
            console.log(`Had an exception and err = ${JSON.stringify(err)}`);
        }
    };

    const handleCancel = (event) => {
        gridApi.stopEditing();
    };

    const changeVerified = (event) => {
        setVerifiedBy(event.target.value);
        if(event.target.value === '---' && (invalidatedReason === '---')){
            setSubmitEnabled(false);
        }
        else if( event.target.value !== '---' && invalidatedReason !== '---'){ //Can't have both values set.
            setSubmitEnabled(false);
        }
        else {
            setSubmitEnabled(true);
        }
    };

    const changeInvalidated = (event) => {
        setInvalidatedReason(event.target.value);
        if(event.target.value === '---' && verifiedBy === '---' ){
            setSubmitEnabled(false);
        }
        else if(event.target.value !== '---' && verifiedBy !== '---' ){
            setSubmitEnabled(false);
        }
        else{
            setSubmitEnabled(true);
        }
    };

    const parseVerifiedByOptions = () => {
        const returnValue =  DropdownOptions[verifiedByOptions].map(option => <option value={option.value}>{option.display}</option>);
        return returnValue;
    }

    const parseInvalidatedReasons = () => {
        const returnValue =  DropdownOptions[invalidatedReasonOptions].map(option => <option value={option.value}>{option.display}</option>);
        return returnValue;
    }

    return (
            // <input onKeyPress={this.onKeyPress} ref={this.textInput} defaultValue={this.props.value}/>
            <form style={{backgroundColor: "white", width:"300px"}} onSubmit={handleSubmit}>
                <div style={{marginLeft: "10px"}}>
                <label>Honorific:<br/><input style={{width: "280px"}} type="text" value={honorific} onChange={(e) => setHonorific(e.target.value)}/></label><br/>
                <label>Given Name:<br/><input style={{width: "280px"}} type="text" value={givenName} onChange={(e) => setGivenName(e.target.value)}/></label><br/>
                <label>Middle Name:<br/><input style={{width: "280px"}} type="text" value={middleName} onChange={(e) => setMiddleName(e.target.value)}/></label><br/>
                <label>Surname:<br/><input style={{width: "280px"}} type="text" value={surname} onChange={(e) => setSurname(e.target.value)}/></label><br/>
                <label>Maturity Suffix:<br/><input style={{width: "280px"}} type="text" value={maturitySuffix} onChange={(e) => setMaturitySuffix(e.target.value)}/></label><br/>
                <label>Verified By:<br/><select style={{width:"280px"}} value={verifiedBy} onChange={changeVerified}>
                    {parseVerifiedByOptions()}
                </select></label><br/>
                <label>Invalidated Reason:<br/><select style={{width:"280px"}} value={invalidatedReason} onChange={changeInvalidated}>
                    {parseInvalidatedReasons()}
                </select></label><br/>
                <button disabled={!submitEnabled}>Submit</button>&nbsp;&nbsp;&nbsp;<button onClick={handleCancel}>Cancel</button><br/><br/><br/>

                <label>Attribute Id (edits not applied): <br/><input style={{width: "280px"}} value={attributeId}/></label>
                </div>
            </form>
    );
});